<template>
  <div>
    <div class="table-container">
      <form method="post" @submit.prevent="createReport">
        <div class="table-title">
          Отчет за {{ GETSTARTDATA.month | getMonth }} {{ GETSTARTDATA.year }}
        </div>
        <div class="categories-top-actions">
          <button class="table-actions-button btn-green" type="submit">
            Создать отчет
          </button>
          <a v-if="this.firstReport" :href="downloadUrlFirst" download>
            <button class="table-actions-button btn-blue" type="button">
              Скачать шаблон
            </button>
          </a>
          <a v-else :href="downloadUrl">
            <button class="table-actions-button btn-blue" type="button">
              Скачать шаблон
            </button>
          </a>

          <button class="table-actions-button btn-upload-file" type="submit">
            <div class="file-area">
              <input
                type="file"
                name="file"
                ref="file"
                id="file"
                @change="submitFile()"
              />
              <div class="file-state">
                <div class="success">Отлично, файл был загружен</div>
                <div class="default">Импорт Excel</div>
              </div>
            </div>
          </button>
        </div>
        <div class="table-container-inner">
          <table id="create_table">
            <thead>
              <tr>
                <td class="table-specs" colspan="2" rowspan="2">
                  Характеристики
                </td>
              </tr>
              <tr class="tr-fixed-height">
                <th
                  class="metall-measure-unit"
                  rowspan="2"
                  colspan="1"
                  scope="colgroup"
                >
                  Единица измерения
                </th>
                <!-- Hide Remnant -->
                <th
                  class="metall-slot-hidden"
                  colspan="3"
                  scope="colgroup"
                  rowspan="2"
                  style="border-top: 1px solid #868686; margin-top: -10px"
                >
                  <button class="show-btn" @click="showRemnantColumns">
                    <i class="fas fa-arrows-alt-h"></i>
                  </button>
                  <p>Показать</p>
                  <span>остаток</span>
                </th>
                <th
                  class="metall-left-in-stock-botm"
                  colspan="3"
                  scope="colgroup"
                >
                  Остаток металлолома на складе на начало месяца
                </th>
                <th class="metall-received" colspan="1" scope="colgroup">
                  <button class="hide-btn" @click="hideRemnantColumns">
                    <i class="fas fa-arrows-alt-h"></i>
                  </button>
                  Поступление
                </th>
                <th class="metall-received" colspan="1" scope="colgroup">
                  Реализация на собственные нужды
                </th>
                <th class="metall-received" colspan="1" scope="colgroup">
                  Социальное обязательство
                </th>
                <th
                  class="metall-slot-hidden-contract"
                  colspan="1"
                  rowspan="1"
                  style="border-top: 1px solid #868686; margin-top: -10px"
                >
                  <button class="show-btn" @click="showContractColumns">
                    <i class="fas fa-arrows-alt-h"></i>
                  </button>
                  <p>Показать информацию о контракте</p>
                </th>
                <th
                  class="metall-information metall-info-contract-cell"
                  colspan="11"
                  scope="colgroup"
                >
                  <button class="hide-btn" @click="hideContractColumns">
                    <i class="fas fa-arrows-alt-h"></i>
                  </button>
                  Информация по заключенным договорам
                </th>
                <th
                  class="metall-left-in-stock-eotm metall-info-notes-cell"
                  colspan="2"
                  scope="colgroup"
                >
                  Остаток металлолома на складе на конец месяца
                </th>
                <th
                  class="metall-slot-hidden-notes top-element"
                  rowspan="2"
                  colspan="1"
                >
                  <button class="show-btn" @click="showNotesColumns">
                    <i class="fas fa-arrows-alt-h"></i>
                  </button>
                  <p>Показать</p>
                  <span>остаток</span>
                </th>
                <th class="metall-notes metall-info-notes-cell" rowspan="2">
                  <button class="hide-btn" @click="hideNotesColumns">
                    <i class="fas fa-arrows-alt-h"></i>
                  </button>
                  Примечание
                </th>
              </tr>
              <tr>
                <th scope="col" style="background: #36429e; border: none"></th>
                <th scope="col" style="background: #36429e; border: none"></th>
                <th class="metall-slot-hidden" scope="col">...</th>
                <!-- <th class="metall-slot-hidden" scope="col">...</th> -->
                <th class="metall-left-in-stock-sub-botm expanded" scope="col">
                  Кол-во
                </th>
                <th class="metall-left-in-stock-sub-botm" scope="col">
                  Стоимость оценки
                </th>
                <th class="metall-left-in-stock-sub-botm expanded" scope="col">
                  Сумма
                </th>
                <th class="metall-received-count" scope="col">Количество</th>
                <th class="metall-slot-hidden-contract" scope="col">...</th>
                <th class="metall-received-count" scope="col">Количество</th>
                <th class="metall-received-count" scope="col">Количество</th>
                <th
                  class="metall-info-sub-count metall-info-contract-cell"
                  scope="col"
                >
                  Общее кол-во по договору
                </th>
                <th
                  class="metall-info-sub-realization metall-info-contract-cell"
                  scope="col"
                >
                  Способ реализации
                </th>
                <th
                  class="metall-info-sub-payment metall-info-contract-cell"
                  scope="col"
                >
                  Условия оплаты
                </th>
                <th
                  class="metall-info-sub-naming metall-info-contract-cell"
                  scope="col"
                >
                  Наименование покупателя
                </th>
                <th
                  class="metall-info-sub-bin metall-info-contract-cell expanded"
                  scope="col"
                >
                  БИН
                </th>
                <th
                  class="metall-info-sub-contract-number metall-info-contract-cell"
                  scope="col"
                >
                  Номер договора
                </th>
                <th
                  class="metall-info-sub-date metall-info-contract-cell"
                  scope="col"
                >
                  Дата договора
                </th>
                <th
                  class="metall-info-sub-price metall-info-contract-cell expanded"
                  scope="col"
                >
                  Цена за ед. тенге
                </th>
                <th
                  class="metall-info-sub-sum metall-info-contract-cell"
                  scope="col"
                >
                  Сумма договора, тенге
                </th>
                <th
                  class="metall-info-sub-exported metall-info-contract-cell"
                  scope="col"
                >
                  Вывезенное количество
                </th>
                <th
                  class="metall-info-sub-left metall-info-contract-cell"
                  scope="col"
                >
                  Остаток по договору
                </th>
                <th
                  class="metall-left-in-stock-sub-eotm metall-info-notes-cell expanded"
                  scope="col"
                >
                  Кол-во
                </th>
                <th
                  class="metall-left-in-stock-sub-eotm metall-info-notes-cell expanded"
                  scope="col"
                >
                  Сумма
                </th>
                <th class="metall-slot-hidden-notes">...</th>
              </tr>
            </thead>
            <tbody id="create_table_tbody">
              <tr v-for="(item, index) in inputParam" :key="index">
                <th>
                  <select
                    :id="'type_' + index"
                    required
                    :class="
                      'special_class report-table-s2 auto_connect_select_' +
                      index
                    "
                    v-model="inputParam[index].type"
                    :disabled="isDis(index)"
                    @change="changeCatalog(index)"
                  >
                    <option value :id="'type_default_' + index">
                      Выберите вид металла
                    </option>
                    <option value="black" :id="'type_black_' + index">
                      Черный металл
                    </option>
                    <option value="color" :id="'type_color_' + index">
                      Цветной металл
                    </option>
                  </select>
                </th>
                <th class="t-metall-sub-type" scope="rowgroup" colspan="1">
                  <select
                    :id="'category_' + index"
                    required
                    :class="'report-table-s2 auto_connect_select_' + index"
                    v-model="inputParam[index].category"
                    :disabled="isDis(index)"
                    @change="
                      getFirstValue(index, inputParam[index].category) ||
                        autoCalculateAfterCount(index) ||
                        autoCalculateBeforeSum(index)
                    "
                  >
                    <option value :id="'category_default_' + index">
                      Выберите категорию
                    </option>
                    <option
                      v-for="catalog in item.catalogs"
                      :key="catalog.id"
                      :value="catalog.name_full"
                    >
                      {{ catalog.name }}
                    </option>
                  </select>
                </th>
                <td>T</td>
                <td class="metall-slot-hidden">...</td>

                <td :id="'td_count_before_' + index" class="metall-td-hide">
                  <input
                    :id="'count_before_' + index"
                    :class="
                      'metall-table-input auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                    type="number"
                    :disabled="idDisAuto(index) || isDisContr(index)"
                    :my_ind="getMyInd(index)"
                    step="0.01"
                    min="0"
                    required
                    v-model="inputParam[index].count_before"
                    @change="
                      autoCalculateAfterCount(index) ||
                        autoCalculateBeforeSum(index)
                    "
                  />
                </td>
                <td :id="'td_price_before_' + index" class="metall-td-hide">
                  <input
                    :id="'price_before_' + index"
                    :class="
                      'metall-table-input auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                    type="number"
                    :disabled="idDisAuto(index)"
                    :my_ind="getMyInd(index)"
                    step="0.01"
                    v-model="inputParam[index].price_before"
                    min="0"
                    required
                    @change="
                      autoCalculateAfterSum(index) ||
                        autoCalculateBeforeSum(index)
                    "
                  />
                </td>
                <td :id="'td_total_before_' + index" class="metall-td-hide">
                  <input
                    :id="'total_before_' + index"
                    :class="
                      'metall-table-input total_calculate auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                    :disabled="idDisAuto(index)"
                    :my_ind="getMyInd(index)"
                    type="number"
                    step="0.01"
                    readonly
                    v-model="inputParam[index].total_before"
                    @change="autoCalculateBeforeSum(index)"
                    min="0"
                  />
                </td>
                <td :id="'td_count_come_' + index" class="metall-td-hide">
                  <input
                    :id="'count_come_' + index"
                    required
                    :class="
                      'metall-table-input auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                    :disabled="idDisAuto(index)"
                    :my_ind="getMyInd(index)"
                    type="number"
                    step="0.01"
                    v-model="inputParam[index].count_come"
                    @change="
                      autoCalculateAfterCount(index) ||
                        autoCalculateAfterSum(index)
                    "
                    min="0"
                  />
                </td>
                <td class="metall-slot-hidden-contract">...</td>
                <td :id="'td_for_own_needs_' + index" class="metall-td-hide">
                  <input
                      :id="'for_own_needs_' + index"
                      required
                      :class="
                      'metall-table-input auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                      :disabled="idDisAuto(index)"
                      :my_ind="getMyInd(index)"
                      type="number"
                      step="0.01"
                      v-model="inputParam[index].for_own_needs"
                      @change="
                      autoCalculateAfterCount(index) ||
                        autoCalculateAfterSum(index)
                    "
                      min="0"
                  />
                </td>
                <td :id="'for_social_commitment_' + index" class="metall-td-hide">
                  <input
                      :id="'for_social_commitment_' + index"
                      required
                      :class="
                      'metall-table-input auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                      :disabled="idDisAuto(index)"
                      :my_ind="getMyInd(index)"
                      type="number"
                      step="0.01"
                      v-model="inputParam[index].for_social_commitment"
                      @change="
                      autoCalculateAfterCount(index) ||
                        autoCalculateAfterSum(index)
                    "
                      min="0"
                  />
                </td>
                <td
                  :id="'contr_count_' + index"
                  class="metall-info-contract-cell"
                >
                  <input
                    required
                    :class="'metall-table-input' + ' dis_contr_' + index"
                    type="number"
                    step="0.01"
                    min="0"
                    :disabled="isDisContr(index)"
                    v-model="inputParam[index].contr_count"
                    @change="
                      autoCalculateContrTotal(index) ||
                        autoCalculateCountBalance(index) ||
                        autoCalculateAfterSum(index) ||
                        deleteRequiredSelect(index)
                    "
                  />
                </td>
                <td class="td_s metall-info-contract-cell">
                  <select
                    :class="
                      'report-table-s selects_' + index + ' dis_contr_' + index
                    "
                    :disabled="isDisContr(index)"
                    v-model="inputParam[index].contr_method"
                    required
                  >
                    <option value>Выберите способ реализации</option>
                    <option value="Аукцион">Аукцион</option>
                    <option value="Товарная биржа">
                      Товарная биржа
                    </option>
                    <option value="Прямая адресная продажа">
                      Прямая адресная продажа
                    </option>
                  </select>
                </td>
                <td class="td_s metall-info-contract-cell">
                  <select
                    :class="
                      'report-table-s selects_' + index + ' dis_contr_' + index
                    "
                    required
                    :disabled="isDisContr(index)"
                    v-model="inputParam[index].contr_conditions"
                  >
                    <option value>Выберите условия оплаты</option>
                    <option value="100% предоплата">100% предоплата</option>
                    <option value="30% предоплата">30% предоплата</option>
                  </select>
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    required
                    :class="
                      'metall-table-input' +
                      ' dis_contr_' +
                      index +
                      ' selects_' +
                      index
                    "
                    type="text"
                    :disabled="isDisContr(index)"
                    v-model="inputParam[index].contr_impl"
                  />
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    required
                    class="bin-input-create"
                    :class="'metall-table-input selects_' + index"
                    type="text"
                    v-model="inputParam[index].bin_company"
                    min="0"
                    maxlength="14"
                    :disabled="isDisContr(index)"
                    @change="contractAutoFilling(index)"
                  />
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    required
                    :class="'metall-table-input selects_' + index"
                    type="text"
                    :disabled="isDisContr(index)"
                    v-model="inputParam[index].contr_number"
                    @change="contractAutoFilling(index)"
                  />
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    required
                    :class="
                      'metall-table-input selects_' +
                      index +
                      ' dis_contr_' +
                      index
                    "
                    type="date"
                    :disabled="isDisContr(index)"
                    v-model="inputParam[index].contr_date"
                  />
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    required
                    :class="
                      'metall-table-input' +
                      ' dis_contr_' +
                      index +
                      ' selects_' +
                      index
                    "
                    type="number"
                    step="0.01"
                    :min="getMin(index)"
                    :disabled="isDisContr(index)"
                    v-model="inputParam[index].contr_unit_price"
                    @change="autoCalculateContrTotal(index)"
                  />
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    required
                    :class="
                      'metall-table-input total_calculate' +
                      ' dis_contr_' +
                      index +
                      ' selects_' +
                      index
                    "
                    type="number"
                    step="0.01"
                    readonly
                    min="0"
                    v-model="inputParam[index].contr_total"
                    @change="autoCalculateContrTotal(index)"
                  />
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    :id="'contr_count_gone_' + index"
                    :gone_ind="index"
                    required
                    :class="'metall-table-input ' + getGoneClass(index)"
                    type="number"
                    step="0.01"
                    min="0"
                    v-model="inputParam[index].contr_count_gone"
                    @change="
                      autoCalculateContrTotal(index) ||
                        autoCalculateCountBalance(index) ||
                        autoCalculateAfterCount(index)
                    "
                  />
                </td>
                <td class="metall-info-contract-cell">
                  <input
                    required
                    :class="
                      'metall-table-input selects_' +
                      index +
                      ' ' +
                      isFirstTotal()
                    "
                    type="number"
                    step="0.01"
                    min="0"
                    v-model="inputParam[index].contr_count_balance"
                    @change="autoCalculateCountBalance(index)"
                    :readonly="isFirstReport()"
                  />
                </td>
                <td class="metall-slot-hidden-notes">...</td>
                <td class="metall-info-notes-cell">
                  <input
                    :class="
                      'metall-table-input total_calculate auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                    type="number"
                    :disabled="idDisAuto(index)"
                    step="0.01"
                    :my_ind="getMyInd(index)"
                    min="0"
                    v-model="inputParam[index].count_after"
                    @change="
                      autoCalculateAfterCount(index) ||
                        autoCalculateAfterSum(index)
                    "
                    readonly
                  />
                </td>
                <td class="metall-info-notes-cell">
                  <input
                    required
                    :class="
                      'metall-table-input total_calculate auto_connect_' +
                      index +
                      ' ' +
                      isDuplicated(index)
                    "
                    type="number"
                    :disabled="idDisAuto(index)"
                    :my_ind="getMyInd(index)"
                    step="0.01"
                    min="0"
                    v-model="inputParam[index].total_after"
                    @change="autoCalculateAfterSum(index)"
                    readonly
                  />
                </td>
                <td class="metall-info-notes-cell">
                  <input
                    class="metall-table-input"
                    type="text"
                    v-model="inputParam[index].comment"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-actions">
          <button
            type="button"
            class="table-actions-button btn-green"
            @click="addRow()"
          >
            <!-- <i class="fa fa-plus" aria-hidden="true"></i> -->
            <i class="material-icons" aria-hidden="true">add</i>
          </button>
          <button
            class="table-actions-button btn-red"
            v-if="inputParam.length > 1"
            type="button"
            @click="deleteRow()"
          >
            <!-- <i class="fa fa-minus" aria-hidden="true"></i> -->
            <i class="material-icons" aria-hidden="true">remove</i>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CreateTableDropDownTwo",
  data() {
    return {
      firstReport: false,
      defaultSelectvalue: "Выберите вид металла",
      start_data: [],
      start_contracts: {},
      contracts_dict: {},
      flag_dict: {},
      catalogList: "",
      blackCatalogs: "",
      colorCatalogs: "",
      inputParam: [
        {
          category: "",
          count_before: "",
          price_before: "",
          total_before: "",
          count_come: "",
          count_after: "",
          total_after: "",
          contr_count: "",
          contr_method: "",
          contr_conditions: "",
          contr_impl: "",
          contr_number: "",
          contr_date: "",
          contr_unit_price: "",
          contr_total: "",
          contr_count_gone: "",
          contr_count_balance: "",
          bin_company: "",
          first_contract: true,
          blackCatalogs: [],
          colorCatalogs: [],
          type: "",
          catalogs: "",
          old_balance: "",
          is_dis: false,
          auto_connect_dis: false,
          my_ind: "",
          dis_contr: false,
        },
      ],
      downloadUrl: `${process.env.VUE_APP_MEDIA_URL}/media/template1.xlsm`,
      downloadUrlFirst: `${process.env.VUE_APP_MEDIA_URL}/media/template2.xlsm`,
    };
  },
  // filters: {
  //   splitNumbers: function (value) {
  //     return value.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ");
  //   },
  // },
  methods: {
    isFirstTotal() {
      if (this.firstReport) {
        return "";
      }
      return "total_calculate";
    },
    isFirstReport() {
      if (this.firstReport) {
        return false;
      }
      return true;
    },
    isDis(index) {
      return this.inputParam[index].is_dis;
    },

    isDisContr(index) {
      return this.inputParam[index].dis_contr;
    },

    getGoneClass(index) {
      if (this.inputParam[index].my_ind !== "") {
        return "gone_class_" + this.inputParam[index].my_ind;
      }
      return "gone_class_" + index;
    },

    getMyInd(index) {
      return this.inputParam[index].my_ind;
    },
    isDuplicated(index) {
      if (this.inputParam[index].auto_connect_dis) {
        this.inputParam[index].count_before = "";
        this.inputParam[index].price_before = "";
        this.inputParam[index].total_before = "";
        this.inputParam[index].count_come = "";
        this.inputParam[index].count_after = "";
        this.inputParam[index].total_after = "";
        return "duplicate";
      }
      return "";
    },
    idDisAuto(index) {
      return this.inputParam[index].auto_connect_dis;
    },
    getMin(index){
      if (this.inputParam[index].contr_count == '0'){
        return 0;
      }
      return 0.01;
    },
    my_insert(arr, index, ...newItems) {
      return [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted items
        ...newItems,
        // part of the array after the specified index
        ...arr.slice(index),
      ];
    },
    getFirstValue(index, value) {
      let curr_index = index;
      if (value in this.flag_dict && !this.flag_dict[value]) {
        let contracts = this.contracts_dict[value];
        for (let i = 0; i < contracts.length; ++i) {
          let contract = contracts[i];
          let auto_connect_diss = true;
          if (i === 0) {
            auto_connect_diss = false;
          }
          let my_type = "Черный металл";
          let my_catalog = this.blackCatalogs;
          if (contract.request.is_color) {
            my_type = "Цветной металл";
            my_catalog = this.colorCatalogs;
          }
          let newInputObject = {
            category: contract.request.category,
            count_before: contract.request.count_after,
            price_before: 0,
            total_before: 0,
            count_come: 0,
            count_after: 0,
            total_after: 0,
            contr_count: contract.contr_count,
            contr_method: contract.contr_method,
            contr_conditions: contract.contr_conditions,
            contr_impl: contract.contr_impl,
            contr_number: contract.contr_number,
            contr_date: contract.contr_date,
            contr_unit_price: contract.contr_unit_price,
            contr_total: contract.contr_total,
            contr_count_gone: 0,
            contr_count_balance: contract.contr_count_balance,
            bin_company: contract.bin_company,
            blackCatalogs: this.blackCatalogs,
            colorCatalogs: this.colorCatalogs,
            first_contract: false,
            type: my_type,
            catalogs: my_catalog,
            old_balance: contract.contr_count_balance,
            is_dis: true,
            auto_connect_dis: auto_connect_diss,
            my_ind: index,
            dis_contr: true,
          };
          curr_index = index + i;

          this.inputParam = this.my_insert(
            this.inputParam,
            curr_index,
            newInputObject
          );
          //this.inputParam.push(newInputObject);
          this.inputParam[curr_index].type = this.inputParam[
            curr_index + 1
          ].type;
          this.inputParam[curr_index].category = this.inputParam[
            curr_index + 1
          ].category;
        }
        this.deleteRow_special();
        this.flag_dict[value] = true;
      } else {
        for (let i = 0; i < this.inputParam.length; ++i) {
          if (this.inputParam[i].category === value && i !== index) {
            if (
              this.inputParam[index].category ===
              this.inputParam[index - 1].category
            ) {
              var auto_conntect_list = document.getElementsByClassName(
                "auto_connect_" + index
              );
              var auto_conntect_select_list = document.getElementsByClassName(
                "auto_connect_select_" + index
              );
              var contr_count_gone = document.getElementById(
                "contr_count_gone_" + index
              );
              Array.prototype.forEach.call(auto_conntect_list, function (el) {
                el.setAttribute("readonly", "readonly");
                el.classList.add("duplicate");
                var el_id_arr = el.id.toString().split("_");
                var el_id = el_id_arr[el_id_arr.length - 1];
                el_id_arr.pop();
                var el_name = el_id_arr.join("_");
                var parent_el_id = parseInt(el_id) - 1;
                var parent_el = document.getElementById(
                  el_name + "_" + parent_el_id
                );
                if (parent_el && parent_el.classList.contains("duplicate")) {
                  el.setAttribute("my_ind", parent_el.getAttribute("my_ind"));
                } else {
                  // parent is main
                  el.setAttribute("my_ind", parent_el_id);
                }
                el.disabled = true;
              });
              Array.prototype.forEach.call(
                auto_conntect_select_list,
                function (el) {
                  el.setAttribute("readonly", "readonly");
                  el.classList.add("duplicate2");
                  var el_id_arr = el.id.toString().split("_");
                  var el_id = el_id_arr[el_id_arr.length - 1];
                  el_id_arr.pop();
                  var el_name = el_id_arr.join("_");
                  var parent_el_id = parseInt(el_id) - 1;
                  var parent_el = document.getElementById(
                    el_name + "_" + parent_el_id
                  );
                  if (parent_el && parent_el.classList.contains("duplicate2")) {
                    el.setAttribute("my_ind", parent_el.getAttribute("my_ind"));
                  } else {
                    // parent is main
                    el.setAttribute("my_ind", parent_el_id);
                  }

                  let type = document.getElementById(
                    "type_" + el.getAttribute("my_ind")
                  );
                  let category = document.getElementById(
                    "category_" + el.getAttribute("my_ind")
                  );
                  type.disabled = true;
                  category.disabled = true;
                  el.disabled = true;
                }
              );

              var curr_count_before = document.getElementById(
                "count_before_" + index
              );

              if (curr_count_before.classList.contains("duplicate")) {
                contr_count_gone.classList.remove("gone_class_" + index);
                contr_count_gone.classList.add(
                  "gone_class_" + curr_count_before.getAttribute("my_ind")
                );
              }

              // call autocalculate
            } else {
              alert("Уже выбрано!!!");
              this.inputParam[index].category = "";
              var default_option = document.getElementById(
                "category_default_" + index
              );
              default_option.setAttribute("selected", "selected");
              return;
            }
          }
        }
        var count_before = document.getElementById("count_before_" + index);
        if (Object.keys(this.start_data).includes(value)) {
          if (!count_before.classList.contains("duplicate")) {
            this.inputParam[index].count_before = this.start_data[value];
          }
          count_before.setAttribute("disabled", "disabled");
        } else {
          count_before.removeAttribute("disabled");
          this.inputParam[index].count_before = "";
        }
      }
    },
    changeCatalog(index) {
      if (this.inputParam[index].type === "black") {
        this.inputParam[index].catalogs = this.blackCatalogs;
      } else if (this.inputParam[index].type === "color") {
        this.inputParam[index].catalogs = this.colorCatalogs;
      } else {
        this.inputParam[index].catalogs = "";
      }
      this.inputParam[index].category = "";
      this.inputParam[index].count_before = "";

      // var default_option = document.getElementById('category_default_' + index);
      // default_option.setAttribute('selected', 'selected');
      // return;
    },
    addRow() {
      let newInputObject = {
        category: "",
        count_before: "",
        price_before: "",
        total_before: "",
        count_come: "",
        count_after: "",
        total_after: "",
        contr_count: "",
        contr_method: "",
        contr_conditions: "",
        contr_impl: "",
        contr_number: "",
        contr_date: "",
        contr_unit_price: "",
        contr_total: "",
        contr_count_gone: "",
        contr_count_balance: "",
        bin_company: "",
        first_contract: true,
        blackCatalogs: this.blackCatalogs,
        colorCatalogs: this.colorCatalogs,
        type: "",
        catalogs: "",
        old_balance: "",
        is_dis: false,
        auto_connect_dis: false,
        my_ind: "",
        dis_contr: false,
      };
      this.inputParam.push(newInputObject);

      this.$nextTick(() => {
        // trigger function immediately after row added
        this.allowCopyPasteDate();
      });
    },
    deleteRow_special() {
      if (this.inputParam.length > 1) {
        this.inputParam.pop();
      }
      if (this.inputParam.length === 1) {
        let type = document.getElementById("type_0");
        let category = document.getElementById("category_0");
        type.disabled = false;
        category.disabled = false;
      }
    },
    deleteRow() {
      let cnt = "";
      let flag = false;
      let index = this.inputParam.length - 1;
      if (this.inputParam.length > 0) {
        let cnt_el = document.getElementById("count_before_" + index);
        cnt = parseInt(cnt_el.id.toString().split("_")[-1]);

        if (cnt_el.classList.contains("duplicate")) {
          cnt = cnt_el.getAttribute("my_ind");
        }
      }

      if (this.inputParam.length > 1) {
        this.inputParam.pop();
        flag = true;
      }
      if (this.inputParam.length === 1) {
        let type = document.getElementById("type_0");
        let category = document.getElementById("category_0");
        type.disabled = false;
        category.disabled = false;
      }

      if (cnt !== "" && flag) {
        let gone_class = document.getElementById("contr_count_gone_" + index);
        gone_class.classList.remove("gone_class_" + cnt);
        this.autoCalculateAfterCount(cnt);
        this.autoCalculateAfterSum(cnt);
      }
    },
    submitFile() {
      const file = document.querySelector("#file"),
        defaultDiv = document.querySelector(".default"),
        successDiv = document.querySelector(".success"),
        parentStateElement = successDiv.parentElement,
        greenBackground = "#36B300";

      let fileName = file.value,
        idxDot = fileName.lastIndexOf(".") + 1,
        extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
      if (!(extFile == "xlsx" || extFile == "xls" || extFile == "xlsm")) {
        alert("Следует загружать следующие типы файлов: xlsx, xls");
        file.value = "";
      } else {
        defaultDiv.style.display = "none";
        successDiv.style.display = "inline-block";
        parentStateElement.style.backgroundColor = greenBackground;

        this.file = this.$refs.file.files[0];

        let formData = new FormData();
        if (this.file) {
          formData.append("file", this.file);
          this.$store.dispatch("importExcel", formData);
        }
      }
    },
    createReport() {
      for (let i = 0; i < this.inputParam.length; ++i) {
        if (this.inputParam[i].contr_count_balance < 0) {
          alert("Значение Остаток по договору меньше нуля");
          return;
        }
        if (this.inputParam[i].contr_count_balance < 0) {
          alert("Значение Количество меньше нуля");
          return;
        }
        if (this.inputParam[i].contr_count_balance < 0) {
          alert("Значение Сумма меньше нуля");
          return;
        }
      }
      const formData = {
        inputParam: this.inputParam,
        is_first: this.firstReport,
      };
      this.$store.dispatch("createReport", formData).catch((error) => {
        if (error.response.status === 423) {
          this.$store.dispatch("addNotification", {
            type: "error",
            message: error.response.data[0],
          });
        }
      });
    },
    getStartDataForCreateReport() {
      this.$store.dispatch("getStartDataForCreateReport").then((response) => {
        this.start_data = response.count_after;
        this.start_contracts = response.contracts;
        this.firstReport = response.first;
      });
    },
    getPreviousContract() {
      this.$store.dispatch("getPreviousContract").then((response) => {
        this.contracts_dict = response.contracts;
        this.flag_dict = response.flag_dict;
      });
    },
    getBlackCatalog() {
      this.$store.dispatch("getBlackCatalog").then((response) => {
        this.blackCatalogs = response;
        this.inputParam[0].blackCatalogs = response;
      });
    },
    getColorCatalog() {
      this.$store.dispatch("getColorCatalog").then((response) => {
        this.colorCatalogs = response;
        this.inputParam[0].colorCatalogs = response;
      });
    },
    autoCalculateContrTotal(index) {
      this.inputParam[index].contr_total = (
        parseFloat(this.inputParam[index].contr_count) *
        parseFloat(this.inputParam[index].contr_unit_price)
      ).toFixed(2);
    },
    autoCalculateCountBalance(index) {
      if (this.firstReport === false) {
        if (this.inputParam[index].old_balance !== "") {
          this.inputParam[index].contr_count_balance = (
            this.inputParam[index].old_balance -
            parseFloat(this.inputParam[index].contr_count_gone)
          ).toFixed(2);
        } else {
          this.inputParam[index].contr_count_balance = (
            this.inputParam[index].contr_count -
            parseFloat(this.inputParam[index].contr_count_gone)
          ).toFixed(2);
        }
      }
    },
    autoCalculateAfterCount(index) {
      var count_befoe = document.getElementById("count_before_" + index);
      var main_index = index;
      if (count_befoe && count_befoe.classList.contains("duplicate")) {
        main_index = count_befoe.getAttribute("my_ind");
      }
      var gone_list = document.getElementsByClassName(
        "gone_class_" + main_index
      );
      var gone_sum = 0.0;
      Array.prototype.forEach.call(gone_list, function (el) {
        gone_sum += parseFloat(el.value);
      });
      if (!gone_sum) {
        gone_sum = 0;
      }
      if (this.inputParam[main_index]) {
        this.inputParam[main_index].count_after = (
          parseFloat(this.inputParam[main_index].count_before) +
          parseFloat(this.inputParam[main_index].count_come) -
          parseFloat(this.inputParam[main_index].for_own_needs) -
          parseFloat(this.inputParam[main_index].for_social_commitment) -
          gone_sum
        ).toFixed(2);
        this.autoCalculateAfterSum(main_index);
      }
    },
    autoCalculateAfterSum(index) {
      if (this.inputParam[index]) {
        this.inputParam[index].total_after = (
          parseFloat(this.inputParam[index].count_after) *
          parseFloat(this.inputParam[index].price_before)
        ).toFixed(2);
      }
    },
    autoCalculateBeforeSum(index) {
      this.inputParam[index].total_before = (
        parseFloat(this.inputParam[index].count_before) *
        parseFloat(this.inputParam[index].price_before)
      ).toFixed(2);
    },
    isNumber(index) {
      let b = Number(this.inputParam[index].bin_company);
      if (!Number.isInteger(b)) {
        this.inputParam[index].bin_company = parseInt(
          this.inputParam[index].bin_company
        );
        alert("БИН компаний должен состоить только из цифр");
      }
    },
    contractAutoFilling(index) {
      var contractNumber = this.inputParam[index].contr_number;
      var binCompany = this.inputParam[index].bin_company;
      if (contractNumber && binCompany) {
        var flag = false;
        for (let i = 0; i < this.start_contracts.length; ++i) {
          if (
            this.start_contracts[i].contr_number === contractNumber &&
            this.start_contracts[i].bin_company === binCompany
          ) {
            flag = true;
            this.inputParam[index].contr_count = this.start_contracts[
              i
            ].contr_count;
            this.inputParam[index].contr_method = this.start_contracts[
              i
            ].contr_method;
            this.inputParam[index].contr_conditions = this.start_contracts[
              i
            ].contr_conditions;
            this.inputParam[index].contr_impl = this.start_contracts[
              i
            ].contr_impl;
            this.inputParam[index].contr_date = this.start_contracts[
              i
            ].contr_date;
            this.inputParam[index].contr_unit_price = this.start_contracts[
              i
            ].contr_unit_price;
            this.inputParam[index].contr_total = this.start_contracts[
              i
            ].contr_total;
            this.inputParam[index].contr_count_balance = this.start_contracts[
              i
            ].contr_count_balance;
            this.inputParam[index].old_balance = this.start_contracts[
              i
            ].contr_count_balance;
            this.inputParam[index].first_contract = false;
            var input_list = document.getElementsByClassName(
              "dis_contr_" + index
            );
            Array.prototype.forEach.call(input_list, function (el) {
              // el.readOnly = true;
              el.setAttribute("disabled", "disabled");
            });
          }
        }
        if (!flag) {
          var input_list_2 = document.getElementsByClassName(
            "dis_contr_" + index
          );
          Array.prototype.forEach.call(input_list_2, function (el) {
            // el.readOnly = true;
            el.removeAttribute("disabled");
          });
        }
      } else {
        // Array.prototype.forEach.call(input_list, function (el){
        //   // el.readOnly = true;
        //   el.removeAttribute('disabled');
        // });
      }
    },

    hideRemnantColumns() {
      let metallLeft = document.querySelectorAll(".metall-left-in-stock-botm"),
        metallSubColumns = document.querySelectorAll(
          ".metall-left-in-stock-sub-botm"
        ),
        metallReceived = document.querySelector(".metall-received"),
        metallReceivedCount = document.querySelector(".metall-received-count"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHidden = document.querySelectorAll(".metall-slot-hidden"),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallLeft.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallReceived.classList.toggle("table-column-hide");
      metallReceivedCount.classList.toggle("table-column-hide");

      metallSubColumns.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHide.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHidden.forEach((item) => {
        item.style.display = "block";
      });

      hideButtons.forEach((item) => {
        item.disabled = true;
      });
    },
    showRemnantColumns() {
      let metallLeft = document.querySelectorAll(".metall-left-in-stock-botm"),
        metallSubColumns = document.querySelectorAll(
          ".metall-left-in-stock-sub-botm"
        ),
        metallReceived = document.querySelector(".metall-received"),
        metallReceivedCount = document.querySelector(".metall-received-count"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHidden = document.querySelectorAll(".metall-slot-hidden"),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallLeft.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallReceived.classList.toggle("table-column-hide");
      metallReceivedCount.classList.toggle("table-column-hide");

      metallSubColumns.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHide.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHidden.forEach((item) => {
        item.style.display = "none";
      });

      hideButtons.forEach((item) => {
        item.disabled = false;
      });
    },
    hideContractColumns() {
      let metallInformation = document.querySelector(".metall-information"),
        metallInfoContractCell = document.querySelectorAll(
          ".metall-info-contract-cell"
        ),
        metallReceivedCount = document.querySelector(".metall-received-count"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHiddenContract = document.querySelectorAll(
          ".metall-slot-hidden-contract"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoContractCell.forEach((item) => {
        item.classList.toggle("table-column-hide");
      });

      metallTdHiddenContract.forEach((item) => {
        item.style.display = "block";
      });

      hideButtons.forEach((item) => {
        item.disabled = true;
      });
    },
    showContractColumns() {
      let metallInformation = document.querySelector(".metall-information"),
        metallInfoContractCell = document.querySelectorAll(
          ".metall-info-contract-cell"
        ),
        metallReceivedCount = document.querySelector(".metall-received"),
        metallTdHide = document.querySelectorAll(".metall-td-hide"),
        metallTdHiddenContract = document.querySelectorAll(
          ".metall-slot-hidden-contract"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoContractCell.forEach((item) => {
        if (item) {
          item.classList.toggle("table-column-hide");
        }
      });

      metallTdHiddenContract.forEach((item) => {
        item.style.display = "none";
      });

      hideButtons.forEach((item) => {
        item.disabled = false;
      });
    },
    hideNotesColumns() {
      let metallInformation = document.querySelector(".metall-notes"),
        metallInfoNotesCells = document.querySelectorAll(
          ".metall-info-notes-cell"
        ),
        metallTdHiddenNotes = document.querySelectorAll(
          ".metall-slot-hidden-notes"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoNotesCells.forEach((item) => {
        item.classList.toggle("table-column-hide");
      });

      metallTdHiddenNotes.forEach((item) => {
        item.style.display = "block";
      });

      hideButtons.forEach((item) => {
        item.disabled = true;
      });
    },
    showNotesColumns() {
      let metallInformation = document.querySelector(".metall-notes"),
        metallInfoNotesCells = document.querySelectorAll(
          ".metall-info-notes-cell"
        ),
        metallTdHiddenNotes = document.querySelectorAll(
          ".metall-slot-hidden-notes"
        ),
        hideButtons = document.querySelectorAll(".hide-btn");

      metallInfoNotesCells.forEach((item) => {
        item.classList.toggle("table-column-hide");
      });

      metallTdHiddenNotes.forEach((item) => {
        item.style.display = "none";
      });

      hideButtons.forEach((item) => {
        item.disabled = false;
      });
    },
    deleteRequiredSelect(index) {
      var all_select = document.getElementsByClassName("selects_" + index);
      if (this.inputParam[index].contr_count == 0) {
        Array.prototype.forEach.call(all_select, function (el) {
          el.removeAttribute("required", "required");
        });
        this.inputParam[index].contr_unit_price = 0;
        this.inputParam[index].contr_total = 0;
        this.inputParam[index].contr_count_gone = 0;
        this.inputParam[index].contr_count_balance = 0;
      } else {
        Array.prototype.forEach.call(all_select, function (el) {
          el.setAttribute("required", "required");
        });
      }
    },
    appendSpaceAtFly() {
      let binEditInputs = document.querySelectorAll(".bin-input-create");
      binEditInputs.forEach((item) => {
        item.addEventListener("input", function (e) {
          let target = e.target,
            position = target.selectionEnd,
            length = target.value.length;

          target.value = target.value
            .replace(/\s/g, "")
            .replace(/(\d{4})/g, "$1 ")
            .trim();
          target.selectionEnd = position +=
            target.value.charAt(position - 1) === " " &&
            target.value.charAt(length - 1) === " " &&
            length !== target.value.length
              ? 1
              : 0;
        });
      });
    },
    binSpace() {
      let binValue = this.$refs.binValue.value;
      binValue = binValue.toString().replace(/^(.{4})(.{4})(.{4})(.*)$/, " ");
    },
    allowCopyPasteDate() {
      let dateInputs = document.querySelectorAll('[type="date"]');
      dateInputs.forEach((el) => {
        el.addEventListener("dblclick", () => {
          el.type = "text";

          // After changing input type with JS .select() wont work as usual
          // Needs timeout fn() to make it work
          setTimeout(() => {
            el.select();
          });
        });

        // register the focusout event to reset the input back to a date input field
        el.addEventListener("focusout", () => {
          el.type = "date";
        });
      });
    },
  },
  mounted() {
    this.getStartDataForCreateReport();
    this.getBlackCatalog();
    this.getPreviousContract();
    this.getColorCatalog();
    this.appendSpaceAtFly();
    this.allowCopyPasteDate();
  },
  computed: {
    ...mapGetters(["GETSTARTDATA", "REPORT"]),
  },
};
</script>

<style scoped>
.duplicate {
  background-color: #717171 !important;
}

.table-container {
  /* overflow-x: auto; */
  padding: 0 2rem;
  /* max-width: 1000px; */
  margin: 0 auto;
}

.table-container-inner {
  padding: 0.5rem;
  margin: 0 2rem;
  /* padding: 1rem 2rem; */
  overflow-x: auto;
  max-width: 100vw;
}

table {
  max-width: 1000px;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto 1rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.table-title {
  padding: 1rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

th,
td {
  border: 1px solid #868686;
  height: 30px;
  padding: 0 1rem;
}

td input:focus,
td select:focus {
  outline: none;
  border: none;
}

.expanded {
  padding: 0 2rem;
}

.table-specs {
  background: #36429e;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.tr-fixed-height {
  height: 100px;
}

.t-metall-type {
  height: 296px;
  width: 120px;
}

.t-metall-sub-type {
  width: 130px;
  height: 60px;
}

.metall-left-in-stock-botm,
.metall-left-in-stock-eotm {
  width: 180px;
  height: 75px;
}

.metall-left-in-stock-sub-botm,
.metall-left-in-stock-sub-eotm {
  width: 90px;
  height: 50px;
}

.metall-received {
  position: relative;
  width: 120px;
}
.metall-information,
.metall-notes {
  position: relative;
}

.table-column-hide {
  /* opacity: 0; */
  /* visibility: hidden; */
  /* appearance: none; */
  display: none;
  /* visibility: collapse; */
}

.table-column-show {
  opacity: 1;
}

.hide-btn,
.show-btn {
  position: absolute;
  top: 0;
  right: 12px;
  padding: 0.5rem;
  background: none;
  border: none;
}

.hide-btn:focus,
.show-btn:focus {
  outline: none;
}

.hide-btn i::before,
.show-btn i::before {
  font-size: 1.2rem;
}
.metall-info-sub-count {
  width: 120px;
}

.metall-info-sub-realization {
  width: 120px;
}

.metall-info-sub-payment {
  width: 90px;
}

.metall-info-sub-naming {
  width: 120px;
}

.metall-info-sub-bin {
  width: 140px;
}

.metall-info-sub-contract-number {
  width: 120px;
}

.metall-info-sub-date {
  width: 110px;
}

.metall-info-sub-price {
  width: 140px;
}

.metall-info-sub-sum {
  width: 140px;
}

.metall-info-sub-exported {
  width: 140px;
}

.metall-info-sub-left {
  width: 140px;
}

/* hidden columns */
.metall-slot-hidden,
.metall-slot-hidden-contract,
.metall-slot-hidden-notes {
  position: relative;
  /* width: 100px; */
  /* height: 75px; */
  display: none;
  border: none;
  /* border-bottom: 1px solid #868686; */
  margin: 0 !important;
}

.metall-slot-hidden p,
.metall-slot-hidden-contract p,
.metall-slot-hidden-notes {
  line-height: 75px;
}

.metall-slot-hidden-notes.top-element {
  border-top: 1px solid black;
}

.metall-table-input {
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
}

#bin-input {
  width: 120px;
}

.categories-top-actions {
  margin: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
}

.btn-upload-file {
  background: none;
  margin-left: -1rem;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-blue {
  background: #36429e;
  color: white;
}

.total_calculate {
  background: rgba(89, 36, 36, 0.27);
}

/* .excel {
  float: right;
  border: grey 1px solid;
  border-radius: 5px;
  display: inline-block;
} */

.file-area {
  width: 100%;
  position: relative;
}

.file-area input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
  border-radius: 25px;
}

.file-area .file-state {
  width: 100%;
  padding: 1rem 1rem;

  border-radius: 10px;
  /* margin-left: 1rem; */
  cursor: pointer;
  font-size: 1.1rem;

  background: #5769f8;
  color: #fff;
  text-align: center;
  transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
  display: none;
}

.file-area:hover .file-state {
  background: rgba(255, 255, 255, 0.1);
  color: black !important;
}

/* .bin-input-create:focus {
  outline: none;
  border: none;
} */

.report-table-s {
  height: 100%;
  border: none;
  font-size: 0.8rem;
  background: none;
  /* text-align: center; */
  margin: 0 auto;
  /* width: 50px !important; */
}

.report-table-s2 {
  height: 100%;
  border: none;
  font-size: 0.8rem;
  background: none;
}

.file-area input[type="file"]:focus + .file-state {
  /* outline: 2px solid rgba(255, 255, 255, 0.5); */
  /* outline: -webkit-focus-ring-color auto 5px; */
}

.custom-th-with-border {
  border: 1px solid #868686;
  background-color: red;
}

/* .file-area input[type=file]:valid+.file-state {
    border-color: #36B300;
    background-color: #36B300;
} */

.file-state-uploaded {
  border-color: #36b300;
  background-color: #36b300;
}

/* .file-area input[type=file]:valid+.file-state .success {
    display: inline-block;
}


.file-area input[type=file]:valid+.file-state .default {
    display: none;
} */

.table-actions {
  display: flex;
  justify-content: center;
  padding-top: 1rem;
}
</style>
